'use client';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Brand from '../Brand';
import ToolMenu from '@/features/tool/components/ToolMenu';
import { NextUI } from '@/components/NextUI';
import { Link } from '@heroui/link';
import React from 'react';
import { useAppDispatch } from '@/hooks/redux';
import { showModal } from '@/store/slices/modalSlice';
import { useTranslations } from 'next-intl';

const Footer = () => {
  return (
    <div className="bg-gray-very-light mt-16 md:mt-0">
      <div className="py-section mt-section hidden md:block">
        <div className="default-container">
          <ToolMenu isFooter={true} />
        </div>
      </div>
      <SubFooter />
    </div>
  );
};

const SubFooter = () => {
  const dispatch = useAppDispatch();
  const t = useTranslations('footer');
  const currentYear = new Date().getFullYear();

  const openContactModal = () => {
    dispatch(
      showModal({
        modalKey: 'Contact',
      })
    );
  };

  const openLanguageModal = () => {
    dispatch(
      showModal({
        modalKey: 'Language',
      })
    );
  };

  return (
    <div>
      <div className="default-container flex flex-col md:flex-row py-8 md:py-16 items-center md:items-start md:justify-between md:border-t-gray-light2 md:border-t">
        <div className="text-center md:text-left">
          <div className="flex justify-center md:justify-start">
            <Brand />
          </div>
          <p className="mt-5 mx-auto md:mx-0 max-w-[352px] md:max-w-[312px] body2 text-gray-light text-[15px]">
            {t('slogan')}
          </p>
          <div className="flex justify-center md:justify-start text-gray-medium gap-4 mt-5 mb-8 md:mb-0">
            <Link
              href="https://xstudios.com.tr/"
              target="_blank"
              className="text-gray-medium"
            >
              <FontAwesomeIcon icon={['fab', 'instagram']} />
            </Link>
            <Link
              href="https://xstudios.com.tr/"
              target="_blank"
              className="text-gray-medium"
            >
              <FontAwesomeIcon icon={['fab', 'facebook-f']} />
            </Link>
            <Link
              href="https://xstudios.com.tr/"
              target="_blank"
              className="text-gray-medium"
            >
              <FontAwesomeIcon icon={['fab', 'x-twitter']} />
            </Link>
            <Link
              href="https://xstudios.com.tr/"
              target="_blank"
              className="text-gray-medium"
            >
              <FontAwesomeIcon icon={['fab', 'linkedin-in']} />
            </Link>
            <Link
              href="https://xstudios.com.tr/"
              target="_blank"
              className="text-gray-medium"
            >
              <FontAwesomeIcon icon={['fab', 'youtube']} />
            </Link>
          </div>
        </div>
        <div className="flex flex-col md:justify-end items-center md:items-end">
          <ul className="[&_a]:body2 [&_a]:text-gray-dark flex flex-col md:flex-row items-center md:items-start gap-4 md:gap-8">
            <li>
              <Link
                href="/refundpolicy"
                className="hover:text-primary-blue text-gray-dark"
              >
                {t('refund_policy')}
              </Link>
            </li>
            <li>
              <Link
                href="/privacy"
                className="hover:text-primary-blue text-gray-dark"
              >
                {t('privacy_notice')}
              </Link>
            </li>
            <li>
              <Link
                href="/terms"
                className="hover:text-primary-blue text-gray-dark"
              >
                {t('terms_of_service')}
              </Link>
            </li>
            <li>
              <Link
                href="/ai-product-terms"
                className="hover:text-primary-blue text-gray-dark"
              >
                {t('ai_product_terms')}
              </Link>
            </li>
            <li>
              <NextUI.Button
                variant="link"
                className="body2 hover:text-primary-blue data-[hover=true]:!opacity-80 text-gray-dark"
                onClick={openContactModal}
              >
                {t('contact_us')}
              </NextUI.Button>
            </li>
          </ul>
          <div className="flex flex-col md:flex-row justify-end items-center mt-8 md:mt-5 gap-4 md:gap-8">
            <p className="text-gray-light body2 order-2 md:order-1">
              {t('copyright', { year: currentYear })}
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Footer;
